define("@embroider/macros/runtime", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.config = config;
  _exports.each = each;
  _exports.getGlobalConfig = getGlobalConfig;
  _exports.isTesting = isTesting;
  _exports.macroCondition = macroCondition;

  /*
    These are the runtime implementations for the javascript macros that have
    runtime implementations.
  
    Not every macro has a runtime implementation, some only make sense in the
    build and always run there.
  
    Even when we have runtime implementations, we are still careful to emit static
    errors during the build wherever possible, and runtime errors when necessary,
    so that you're not surprised when you switch from runtime-mode to compile-time
    mode.
  */

  /*
    CAUTION: in classic builds, this file gets shared by all present copies of
    @embroider/macros. If you want to change its public API, you need to rename it
    and update `pathToRuntime` in ../babel/state.ts to point at it, so that your
    babel plugin and runtime will match.
  */
  function each(array) {
    if (!Array.isArray(array)) {
      throw new Error("the argument to the each() macro must be an array");
    }

    return array;
  }

  function macroCondition(predicate) {
    return predicate;
  } // This is here as a compile target for `getConfig` and `getOwnConfig` when
  // we're in runtime mode. This is not public API to call from your own code.


  function config(packageRoot) {
    return runtimeConfig.packages[packageRoot];
  }

  function getGlobalConfig() {
    return runtimeConfig.global;
  }

  function isTesting() {
    let g = runtimeConfig.global;
    let e = g && g['@embroider/macros'];
    return Boolean(e && e.isTesting);
  }

  const runtimeConfig = initializeRuntimeMacrosConfig(); // this exists to be targeted by our babel plugin

  function initializeRuntimeMacrosConfig() {
    return {
      "packages": {
        "/home/circleci/later/node_modules/ember-get-config": {
          "config": {
            "zendeskKey": "d2549f48-39e9-4bce-b364-3743deab0de8",
            "modulePrefix": "later",
            "environment": "production",
            "rootURL": "/",
            "locationType": "auto",
            "EmberENV": {
              "FEATURES": {},
              "EXTEND_PROTOTYPES": {
                "Date": false
              },
              "_APPLICATION_TEMPLATE_WRAPPER": false,
              "_DEFAULT_ASYNC_OBSERVERS": true,
              "_JQUERY_INTEGRATION": false,
              "_TEMPLATE_ONLY_GLIMMER_COMPONENTS": true
            },
            "emberRollbarClient": {
              "enabled": true,
              "accessToken": "a847e1b1f4c946289495fcb088489a49",
              "verbose": true,
              "captureUncaught": true,
              "captureUnhandledRejections": true,
              "payload": {
                "environment": "production",
                "client": {
                  "javascript": {
                    "source_map_enabled": true,
                    "code_version": "1.22.5+e0ab349",
                    "guess_uncaught_frames": true
                  }
                }
              },
              "hostWhiteList": ["laterdev.ngrok.io", "app.later.com", "staging.later.com", "scratch.later.com", "later-frontend-assets.later.com"]
            },
            "APP": {
              "environment": "production",
              "AWS": {
                "identityPoolId": "us-east-1:f6e04ac8-3462-4707-9f13-aebfd7214c95"
              },
              "facebookGraphVersion": "10.0",
              "firebaseDevKey": "AIzaSyCOS1YaLFLlwS9wZxawlWQxd42gRTtxrd8",
              "firebaseProdKey": "AIzaSyCfK-qpjYbQr-GHxU_JRKCm-HgtNCcIuQg",
              "firebaseAdminPw": "g6#U!7vvNp",
              "disablePerformanceTracking": false,
              "googleAppId": "resonant-kayak-820",
              "instagramUsernameEndpoint": "https://0cg8b5bod3.execute-api.us-east-1.amazonaws.com/prod/get_username",
              "statusPageSummaryEndpoint": "https://hwl0tlgv8kg1.statuspage.io/api/v2/summary.json",
              "postModalSandbox": true,
              "dropboxAppKey": "rzt9532nni3smlk",
              "partnerstackPublicKey": "pk_HlhaYt9F3qnMUZI0FVtRoLQuALvJOjTc",
              "partnerstackSecretKey": "sk_UwCIe3IJrwhNo70oZqCr7Tl8SCbRT1p4",
              "brightbackAppId": "9Nyv3PnrQJ",
              "deployTarget": "production",
              "datadogAppId": "965c9398-fd35-4a81-bda7-c4e9072712c3",
              "datadogClientToken": "pubb7659bcaea5bbe133d6b229bcdfa8817",
              "APP_VERSION": "production",
              "APP_VERSION_INT": null,
              "name": "later",
              "version": "1.22.5+e0ab349a"
            },
            "contentSecurityPolicy": {
              "report-uri": "https://csp-report.browser-intake-datadoghq.com/api/v2/logs?dd-api-key=pubb7659bcaea5bbe133d6b229bcdfa8817&dd-evp-origin=content-security-policy&ddsource=csp-report&ddtags=service%3Aember-later%2Cenv%3Aproduction",
              "default-src": ["'none'"],
              "frame-src": ["'self'", "http://*.facebook.com", "http://fast.wistia.com", "https://*.facebook.com", "https://*.tiktok.com/", "https://*.youtube.com", "https://accounts.google.com", "https://checkout.stripe.com", "https://content.googleapis.com", "https://fast.wistia.com", "https://js.stripe.com", "https://l8r.it", "https://later.ada.support", "https://linkin.bio", "https://platform.twitter.com", "https://soo.nr", "https://staging.linkin.bio"],
              "script-src": ["'self'", "'report-sample'", "'unsafe-inline'", "'unsafe-eval'", "api.pinterest.com", "apis.google.com", "js.stripe.com", "localhost:4200", "http://cdn.mxpnl.com", "http://fast.appcues.com", "http://fast.fonts.net", "http://fast.wistia.com", "http://fast.wistia.net", "https://edge.fullstory.com/", "https://rs.fullstory.com", "http://*.facebook.net", "https://static.klaviyo.com/", "https://snap.licdn.com/", "https://api.instagram.com", "https://api.rollbar.com", "https://cdn.amplitude.com/", "https://cdn.jsdelivr.net", "https://cdnjs.cloudflare.com", "https://cdn.segment.com/", "https://checkout.stripe.com/checkout.js", "https://js.intercomcdn.com", "https://laterdev.ngrok.io:4200", "https://platform.twitter.com", "https://script.google.com", "https://widget.intercom.io/", "https://widget-mediator.zopim.com", "https://www.dropbox.com", "https://www.google-analytics.com/", "https://*.facebook.com", "https://*.later.com", "https://*.zdassets.com", "https://code.highcharts.com/mapdata/custom/world.js", "https://unpkg.com/jcrop@3.0.1/dist/jcrop.js", "https://*.googletagmanager.com", "https://app.brightback.com/js/current/brightback.js", "https://static.ada.support/embed2.js", "https://static.ada.support/embed/modern/client/", "https://static.ada.support/", "https://cdn.segment.com/v1/projects/M8EqR6z0JKKU8e2139uoNZxtstaLUicu/settings", "https://cdn.segment.com/analytics-next/bundles/*", "https://cdn.segment.com/next-integrations/integrations/*"],
              "font-src": ["'self'", "data:", "http://fast.fonts.net", "http://fonts.gstatic.com", "https://*.later.com", "https://js.intercomcdn.com"],
              "connect-src": ["'self'", "data:", "http://*.later.com", "https://*.amazonaws.com", "https://*.cloudfront.net", "https://*.facebook.com", "https://*.google-analytics.com", "https://*.googleapis.com", "https://*.instagram.com", "https://*.later.com", "https://*.litix.io", "https://*.myshopify.com", "https://*.statuspage.io/api/v2/summary.json", "https://*.tiktok.com", "https://*.wistia.com", "https://*.zdassets.com", "https://a.klaviyo.com/", "https://api-iam.intercom.io", "https://api.amplitude.com", "https://api.rollbar.com", "https://api.segment.io", "https://api.unsplash.com", "https://apis.google.com", "https://app.brightback.com/precancel", "https://app.later.com/time", "https://checkout.stripe.com", "https://distillery.wistia.com", "https://dl.dropboxusercontent.com", "https://fast.a.klaviyo.com/", "https://firebase.googleapis.com", "https://later.ada.support/", "https://latermedia.zendesk.com", "https://ekr.zendesk.com", "https://pipedream.wistia.com", "https://rollout.ada.support/later/client.json", "https://static.ada.support/chat-manifest.json", "https://static.ada.support/embed-manifest.json", "https://logs.browser-intake-datadoghq.com/api/v2/logs", "https://rum.browser-intake-datadoghq.com/api/v2/rum", "wss://*.later.com", "wss://api.appcues.net/", "wss://localhost:4200", "wss://nexus-websocket-a.intercom.io", "wss://widget-mediator.zopim.com", "https://cdn.segment.com/v1/projects/M8EqR6z0JKKU8e2139uoNZxtstaLUicu/settings", "https://cdn.segment.com/analytics-next/bundles/*", "https://cdn.segment.com/next-integrations/integrations/*", "https://edge.fullstory.com", "https://rs.fullstory.com"],
              "img-src": ["'self'", "blob:", "data:", "fast.fonts.net", "placekitten.com", "s3.amazonaws.com", "*.akamaihd.net", "*.cdninstagram.com", "*.cloudfront.net", "*.facebook.com", "*.fbcdn.net", "*.fbsbx.com", "*.igsonar.com", "*.instagram.com", "*.pinimg.com", "*.s3.amazonaws.com", "*.twimg.com", "*.unsplash.com", "*.tiktokcdn.com", "http://placekitten.com", "https://avatars.io", "https://cdn.jsdelivr.net", "https://cdn.shopify.com", "https://csi.gstatic.com", "https://embed-fastly.wistia.com", "https://fast.wistia.com", "https://fast.wistia.net", "https://js.intercomcdn.com", "https://later-frontend-assets.later.com", "https://media-exp1.licdn.com", "https://q.stripe.com", "https://static.intercomassets.com", "http://www.gravatar.com", "https://www.tiktok.com", "https://rs.fullstory.com"],
              "style-src": ["'self'", "'report-sample'", "'unsafe-inline'", "*.cloudfront.net", "http://fast.fonts.net", "http://fast.appcues.com", "http://fonts.googleapis.com", "https://cdn.jsdelivr.net", "https://cdnjs.cloudflare.com", "https://connect.facebook.net", "https://fast.wistia.com", "https://www.dropbox.com"],
              "media-src": ["'self'", "data:", "s3.amazonaws.com", "*.cdninstagram.com", "*.cloudfront.net", "*.facebook.com", "*.fbcdn.net", "*.s3.amazonaws.com", "https://static.zdassets.com/", "https://embed-fastly.wistia.com", "https://embedwistia-a.akamaihd.net", "https://js.intercomcdn.com"]
            },
            "ember-load": {
              "loadingIndicatorClass": "ember-load-indicator"
            },
            "flashMessageDefaults": {
              "destroyOnClick": false
            },
            "ember-simple-auth": {
              "authenticationRoute": "user.login",
              "routeIfAlreadyAuthenticated": "index"
            },
            "contentSecurityPolicyHeader": "Content-Security-Policy-Report-Only",
            "ember-cli-mirage": {
              "usingProxy": false,
              "useDefaultPassthroughs": true
            },
            "exportApplicationGlobal": false
          },
          "testConfig": {
            "zendeskKey": "d2549f48-39e9-4bce-b364-3743deab0de8",
            "modulePrefix": "later",
            "environment": "test",
            "rootURL": "/",
            "locationType": "none",
            "EmberENV": {
              "FEATURES": {},
              "EXTEND_PROTOTYPES": {
                "Date": false
              },
              "_APPLICATION_TEMPLATE_WRAPPER": false,
              "_DEFAULT_ASYNC_OBSERVERS": true,
              "_JQUERY_INTEGRATION": false,
              "_TEMPLATE_ONLY_GLIMMER_COMPONENTS": true
            },
            "emberRollbarClient": {
              "enabled": false,
              "accessToken": "a847e1b1f4c946289495fcb088489a49",
              "verbose": true,
              "captureUncaught": false,
              "captureUnhandledRejections": false,
              "payload": {
                "environment": "production",
                "client": {
                  "javascript": {
                    "source_map_enabled": true,
                    "code_version": "1.22.5+e0ab349",
                    "guess_uncaught_frames": true
                  }
                }
              },
              "hostWhiteList": ["laterdev.ngrok.io", "app.later.com", "staging.later.com", "scratch.later.com", "later-frontend-assets.later.com"]
            },
            "APP": {
              "environment": "test",
              "AWS": {
                "identityPoolId": "us-east-1:f6e04ac8-3462-4707-9f13-aebfd7214c95"
              },
              "facebookGraphVersion": "10.0",
              "firebaseDevKey": "AIzaSyCOS1YaLFLlwS9wZxawlWQxd42gRTtxrd8",
              "firebaseProdKey": "AIzaSyCfK-qpjYbQr-GHxU_JRKCm-HgtNCcIuQg",
              "firebaseAdminPw": "g6#U!7vvNp",
              "disablePerformanceTracking": false,
              "googleAppId": "resonant-kayak-820",
              "instagramUsernameEndpoint": "https://0cg8b5bod3.execute-api.us-east-1.amazonaws.com/prod/get_username",
              "statusPageSummaryEndpoint": "https://hwl0tlgv8kg1.statuspage.io/api/v2/summary.json",
              "postModalSandbox": true,
              "dropboxAppKey": "rzt9532nni3smlk",
              "partnerstackPublicKey": "pk_HlhaYt9F3qnMUZI0FVtRoLQuALvJOjTc",
              "partnerstackSecretKey": "sk_UwCIe3IJrwhNo70oZqCr7Tl8SCbRT1p4",
              "brightbackAppId": "9Nyv3PnrQJ",
              "deployTarget": "production",
              "datadogAppId": "965c9398-fd35-4a81-bda7-c4e9072712c3",
              "datadogClientToken": "pubb7659bcaea5bbe133d6b229bcdfa8817",
              "LOG_ACTIVE_GENERATION": false,
              "LOG_VIEW_LOOKUPS": false,
              "rootElement": "#ember-testing",
              "autoboot": false,
              "APP_VERSION": "test",
              "APP_VERSION_INT": null,
              "name": "later",
              "version": "1.22.5+e0ab349a"
            },
            "contentSecurityPolicy": {
              "report-uri": "https://csp-report.browser-intake-datadoghq.com/api/v2/logs?dd-api-key=pubb7659bcaea5bbe133d6b229bcdfa8817&dd-evp-origin=content-security-policy&ddsource=csp-report&ddtags=service%3Aember-later%2Cenv%3Atest",
              "default-src": ["'none'"],
              "frame-src": ["'self'", "http://*.facebook.com", "http://fast.wistia.com", "https://*.facebook.com", "https://*.tiktok.com/", "https://*.youtube.com", "https://accounts.google.com", "https://checkout.stripe.com", "https://content.googleapis.com", "https://fast.wistia.com", "https://js.stripe.com", "https://l8r.it", "https://later.ada.support", "https://linkin.bio", "https://platform.twitter.com", "https://soo.nr", "https://staging.linkin.bio"],
              "script-src": ["'self'", "'report-sample'", "'unsafe-inline'", "'unsafe-eval'", "api.pinterest.com", "apis.google.com", "js.stripe.com", "localhost:4200", "http://cdn.mxpnl.com", "http://fast.appcues.com", "http://fast.fonts.net", "http://fast.wistia.com", "http://fast.wistia.net", "https://edge.fullstory.com/", "https://rs.fullstory.com", "http://*.facebook.net", "https://static.klaviyo.com/", "https://snap.licdn.com/", "https://api.instagram.com", "https://api.rollbar.com", "https://cdn.amplitude.com/", "https://cdn.jsdelivr.net", "https://cdnjs.cloudflare.com", "https://cdn.segment.com/", "https://checkout.stripe.com/checkout.js", "https://js.intercomcdn.com", "https://laterdev.ngrok.io:4200", "https://platform.twitter.com", "https://script.google.com", "https://widget.intercom.io/", "https://widget-mediator.zopim.com", "https://www.dropbox.com", "https://www.google-analytics.com/", "https://*.facebook.com", "https://*.later.com", "https://*.zdassets.com", "https://code.highcharts.com/mapdata/custom/world.js", "https://unpkg.com/jcrop@3.0.1/dist/jcrop.js", "https://*.googletagmanager.com", "https://app.brightback.com/js/current/brightback.js", "https://static.ada.support/embed2.js", "https://static.ada.support/embed/modern/client/", "https://static.ada.support/", "https://cdn.segment.com/v1/projects/M8EqR6z0JKKU8e2139uoNZxtstaLUicu/settings", "https://cdn.segment.com/analytics-next/bundles/*", "https://cdn.segment.com/next-integrations/integrations/*"],
              "font-src": ["'self'", "data:", "http://fast.fonts.net", "http://fonts.gstatic.com", "https://*.later.com", "https://js.intercomcdn.com"],
              "connect-src": ["'self'", "data:", "http://*.later.com", "https://*.amazonaws.com", "https://*.cloudfront.net", "https://*.facebook.com", "https://*.google-analytics.com", "https://*.googleapis.com", "https://*.instagram.com", "https://*.later.com", "https://*.litix.io", "https://*.myshopify.com", "https://*.statuspage.io/api/v2/summary.json", "https://*.tiktok.com", "https://*.wistia.com", "https://*.zdassets.com", "https://a.klaviyo.com/", "https://api-iam.intercom.io", "https://api.amplitude.com", "https://api.rollbar.com", "https://api.segment.io", "https://api.unsplash.com", "https://apis.google.com", "https://app.brightback.com/precancel", "https://app.later.com/time", "https://checkout.stripe.com", "https://distillery.wistia.com", "https://dl.dropboxusercontent.com", "https://fast.a.klaviyo.com/", "https://firebase.googleapis.com", "https://later.ada.support/", "https://latermedia.zendesk.com", "https://ekr.zendesk.com", "https://pipedream.wistia.com", "https://rollout.ada.support/later/client.json", "https://static.ada.support/chat-manifest.json", "https://static.ada.support/embed-manifest.json", "https://logs.browser-intake-datadoghq.com/api/v2/logs", "https://rum.browser-intake-datadoghq.com/api/v2/rum", "wss://*.later.com", "wss://api.appcues.net/", "wss://localhost:4200", "wss://nexus-websocket-a.intercom.io", "wss://widget-mediator.zopim.com", "https://cdn.segment.com/v1/projects/M8EqR6z0JKKU8e2139uoNZxtstaLUicu/settings", "https://cdn.segment.com/analytics-next/bundles/*", "https://cdn.segment.com/next-integrations/integrations/*", "https://edge.fullstory.com", "https://rs.fullstory.com"],
              "img-src": ["'self'", "blob:", "data:", "fast.fonts.net", "placekitten.com", "s3.amazonaws.com", "*.akamaihd.net", "*.cdninstagram.com", "*.cloudfront.net", "*.facebook.com", "*.fbcdn.net", "*.fbsbx.com", "*.igsonar.com", "*.instagram.com", "*.pinimg.com", "*.s3.amazonaws.com", "*.twimg.com", "*.unsplash.com", "*.tiktokcdn.com", "http://placekitten.com", "https://avatars.io", "https://cdn.jsdelivr.net", "https://cdn.shopify.com", "https://csi.gstatic.com", "https://embed-fastly.wistia.com", "https://fast.wistia.com", "https://fast.wistia.net", "https://js.intercomcdn.com", "https://later-frontend-assets.later.com", "https://media-exp1.licdn.com", "https://q.stripe.com", "https://static.intercomassets.com", "http://www.gravatar.com", "https://www.tiktok.com", "https://rs.fullstory.com"],
              "style-src": ["'self'", "'report-sample'", "'unsafe-inline'", "*.cloudfront.net", "http://fast.fonts.net", "http://fast.appcues.com", "http://fonts.googleapis.com", "https://cdn.jsdelivr.net", "https://cdnjs.cloudflare.com", "https://connect.facebook.net", "https://fast.wistia.com", "https://www.dropbox.com"],
              "media-src": ["'self'", "data:", "s3.amazonaws.com", "*.cdninstagram.com", "*.cloudfront.net", "*.facebook.com", "*.fbcdn.net", "*.s3.amazonaws.com", "https://static.zdassets.com/", "https://embed-fastly.wistia.com", "https://embedwistia-a.akamaihd.net", "https://js.intercomcdn.com"]
            },
            "ember-load": {
              "loadingIndicatorClass": "ember-load-indicator"
            },
            "flashMessageDefaults": {
              "destroyOnClick": false
            },
            "ember-simple-auth": {
              "authenticationRoute": "user.login",
              "routeIfAlreadyAuthenticated": "index"
            },
            "ember-cli-mirage": {
              "trackRequests": true,
              "usingProxy": false,
              "useDefaultPassthroughs": true
            },
            "contentSecurityPolicyHeader": "Content-Security-Policy-Report-Only",
            "exportApplicationGlobal": true
          }
        }
      },
      "global": {
        "@embroider/macros": {
          "isTesting": false
        }
      }
    };
  }

  function updaterMethods() {
    return {
      config,
      getGlobalConfig,

      setConfig(packageRoot, value) {
        runtimeConfig.packages[packageRoot] = value;
      },

      setGlobalConfig(key, value) {
        runtimeConfig.global[key] = value;
      }

    };
  } // this is how runtime config can get injected at boot. I'm not sure yet if this
  // should be public API, but we certainly need it internally to set things like
  // the global fastboot.isRunning.
  //
  // consumers of this API push a function onto
  // window._embroider_macros_runtime_config. The function is given four methods
  // which allow it to read and write the per-package and global configs. The
  // reason for allowing both read & write is that merging strategies are up to
  // each consumers -- read first, then merge, then write.
  //
  // For an example user of this API, see where we generate
  // embroider_macros_fastboot_init.js' in @embroider/core.


  let updaters = typeof window !== 'undefined' ? window._embroider_macros_runtime_config : undefined;

  if (updaters) {
    let methods = updaterMethods();

    for (let updater of updaters) {
      updater(methods);
    }
  }
});